import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { TppServiceBeneficiaryDTO } from "@shared/models/tpp-service.interface";
import { environment as env } from "@environments/environment";

@Injectable({
	providedIn: "root"
})
export class TppApiServiceService {
	private http: HttpClient = inject(HttpClient);

	createTPPAccount(account: TppServiceBeneficiaryDTO): Observable<TppServiceBeneficiaryDTO> {
		return this.http.post<TppServiceBeneficiaryDTO>(`${env.apiUri}/v1/accounts/tpp`, account);
	}

	updateTPPAccount(account: TppServiceBeneficiaryDTO): Observable<TppServiceBeneficiaryDTO> {
		return this.http.put<TppServiceBeneficiaryDTO>(`${env.apiUri}/v1/accounts/tpp`, account);
	}
}
